import * as Yup from 'yup'
import { cloneDeep } from 'lodash'
import postDataApi from '@/methods/postDataApi'

const API_URL = 'https://us-central1-redso-frontend-prod.cloudfunctions.net/enquiry'

const formikConfig = (props) => {
  const { setIsSubmitted, setIsSucceeded, $t } = props
  console.log({ $t });
  console.log($t.TXT_Help_Error_name);
  console.log($t.TXT_Help_Error_email);
  console.log($t.TXT_Help_Error_email_valid);
  return {
    validationSchema: Yup.object().shape({
      name: Yup.string().required($t.TXT_Help_Error_name),
      email: Yup.string()
        .required($t.TXT_Help_Error_email)
        .matches(/\S+@\S+\.\S+/, $t.TXT_Help_Error_email_valid),
    }),

    initialValues: {
      name: '',
      email: '',
      phone: '',
      remark: '',
    },

    onSubmit (values) {
      const submitData = {
        product: 'recards',
        service: ['Others'],
        solution: ['recards'],
        ...cloneDeep(values),
      }

      setIsSubmitted(true)

      postDataApi(API_URL, submitData)
        .then((data) => {
          if (data.status === 200) {
            setIsSucceeded(true)
          } else {
            console.error(data)
          }
        })
        .catch((error) => console.log('postDataApi error', error))
    },
  }
}

export default formikConfig
